import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import KnowledgeBaseModuleSection from "../../Sections/Knowledgebase/ModuleListPage";

const KnowledgeBaseModuleComponent = () => {
  return <Dashboard sectionName={<KnowledgeBaseModuleSection />} />;
};

export default KnowledgeBaseModuleComponent;
